import { Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import * as es from 'date-fns/locale/es';
import { DatepickerOptions, NgDatepickerComponent } from 'ng2-datepicker';

const locales = { es };
const placeholders = {
  es: 'Selecciona fecha'
};
const defaultFormat = {
  es: 'D/MM/YYYY'
};

export enum Position {
  BOTTOM_LEFT = 'bottom-left',
  BOTTOM_RIGHT = 'bottom-right',
  TOP_LEFT = 'top-left',
  TOP_RIGHT = 'top-right'
}

@Component({
  selector: 'bidi-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => DatepickerComponent), multi: true }
  ]
})
export class DatepickerComponent implements ControlValueAccessor, OnInit {
  @Input() valueDate: any;
  @Input() locale = 'es';
  @Input() displayFormat;
  @Input() position: Position = Position.BOTTOM_RIGHT;
  @Input() options: DatepickerOptions = {};
  @Output() ngModelChange = new EventEmitter<Date>();
  @ViewChild('ref') ngDatepicker: NgDatepickerComponent;
  finalOptions: DatepickerOptions;

  private innerValue;
  private onChangeCallback: (_: Date) => void;

  get value () {
    return this.innerValue;
  }

  set value (date: Date) {
    if (this.innerValue !== date) {
      this.innerValue = date;
    }

    if (this.onChangeCallback) {
      this.onChangeCallback(this.innerValue);
    }
  }

  private defaultOptions: DatepickerOptions = {
    barTitleFormat: 'MMMM YYYY',
    dayNamesFormat: 'dd',
    firstCalendarDay: 1,
    addClass: 'input',
    useEmptyBarTitle: false
  };

  ngOnInit () {
    this.finalOptions = Object.assign(
      {
        displayFormat: this.displayFormat || defaultFormat[this.locale],
        locale: locales[this.locale],
        placeholder: placeholders[this.locale]
      },
      this.defaultOptions,
      this.options
    );
  }

  registerOnChange (fn: any) {
    this.onChangeCallback = fn;
    this.ngDatepicker.registerOnChange(fn);
  }

  registerOnTouched (fn: any) {
    this.ngDatepicker.registerOnTouched(fn);
  }

  setDisabledState (isDisabled: boolean) {
    this.ngDatepicker.setDisabledState(isDisabled);
  }

  writeValue (date: Date) {
    if (this.innerValue !== date) {
      this.innerValue = date;
    }
  }
}
